import {Button, LinkButton} from '@sdox/ui'

import {useGenericButtonProps} from './utils'
import {DialogButton} from './DialogButton'
import {DocumentButton} from './DocumentButton/DocumentButton'
import {NestedContentButton} from './NestedContentButton/NestedContentButton'

import type {GenericButtonProps} from './utils'
import type {ButtonProps, LinkButtonProps} from '@sdox/ui'
import type {ButtonInterface_DialogButtonType_Fragment, ButtonInterface_DocButtonType_Fragment, ButtonInterface_NestedContentButtonType_Fragment} from '@sdox/api'

export const GenericButton = (props: GenericButtonProps) => {
  const btnProps = useGenericButtonProps(props)

  switch (props.__typename) {
    // missing ContactFormTriggerButtonType
    case 'HrefButtonType':
      return <LinkButton {...btnProps as LinkButtonProps} />
    case 'DownloadButtonType':
      return <LinkButton {...btnProps as LinkButtonProps} />
    case 'CopyButtonType':
      return <Button {...btnProps as ButtonProps} />
    case 'DocButtonType':
      return <DocumentButton {...props as ButtonInterface_DocButtonType_Fragment} />
    case 'DialogButtonType':
      return <DialogButton {...props as ButtonInterface_DialogButtonType_Fragment} />
    case 'NestedContentButtonType':
      return <NestedContentButton {...props as ButtonInterface_NestedContentButtonType_Fragment} />
    default:
      return null
  }
}
